document.addEventListener("DOMContentLoaded", (event) => {
    /* Add the custom Code Here !! */

    /* Custom engraving Code -- START */
    (() => {
    /* Centralized error logging. */
    const handleError = (error, context = '') => {
        console.error(
        `[Engraving Options]${context ? ` ${context}:` : ''}`,
        error
        );
    };

    try {
        const getContainers = () => {
        try {
            return document.querySelectorAll(
            '[data-engraving-options]'
            );
        } catch (error) {
            handleError(error, 'Failed to find engraving containers');
            return [];
        }
        };

        /* Get variant title. */
        const getVariantTitle = (variant) => {
        try {
            return (
            variant?.title ||
            variant?.name ||
            ''
            ).toString().toLowerCase();
        } catch (error) {
            handleError(error, 'Failed to get variant title');
            return '';
        }
        };

        /*
        * Update engraving visibility.
        *
        * IMPORTANT:
        * Query the DOM every time because Shopify can
        * replace the product section during variant changes.
        */
        const updateEngravingVisibility = (variant) => {
        try {
            const variantTitle = getVariantTitle(variant);

            if (!variantTitle) {
            console.warn(
                '[Engraving Options] Variant title is missing.'
            );

            return;
            }

            const isBundle = variantTitle.includes('bundle');

            console.log('Updating engraving:', {
            variantTitle,
            isBundle
            });

            getContainers().forEach((container) => {
            try {
                if (!container) {
                return;
                }

                const normalGroup = container.querySelector(
                '[data-engraving-group="normal"]'
                );

                const bundleGroup = container.querySelector(
                '[data-engraving-group="bundle"]'
                );

                const setGroupActive = (group, isActive) => {
                if (!group) {
                    return;
                }

                group.hidden = !isActive;

                /*
                 * Disable inactive fields so hidden required
                 * inputs do not block form submission.
                 */
                group
                    .querySelectorAll('input, select, textarea')
                    .forEach((field) => {
                    field.disabled = !isActive;
                    });
                };

                setGroupActive(normalGroup, !isBundle);
                setGroupActive(bundleGroup, isBundle);
            } catch (error) {
                handleError(
                error,
                'Failed to update engraving container'
                );
            }
            });
        } catch (error) {
            handleError(
            error,
            'Failed to update engraving visibility'
            );
        }
        };

        /*
         * Validate engraving text + font fields with
         * inline errors (no native browser tooltips/alerts).
         */
        const getFormContainers = (form) => {
        const formId = form.getAttribute('id');

        return [...getContainers()].filter((container) => {
            if (!formId) {
            return form.contains(container);
            }

            return (
            form.contains(container) ||
            container.querySelector(`[form="${formId}"]`)
            );
        });
        };

        const clearTextError = (input) => {
        try {
            if (!input) {
            return;
            }

            input.classList.remove('is-invalid');
            input.removeAttribute('aria-invalid');

            const error = input
            .closest('.engraving-option')
            ?.querySelector('[data-text-error]');

            if (error) {
            error.hidden = true;
            error.classList.remove('is-visible');
            }
        } catch (error) {
            handleError(error, 'Failed to clear text error');
        }
        };

        const showTextError = (input) => {
        try {
            if (!input) {
            return;
            }

            input.classList.add('is-invalid');
            input.setAttribute('aria-invalid', 'true');

            const error = input
            .closest('.engraving-option')
            ?.querySelector('[data-text-error]');

            if (error) {
            error.hidden = false;
            error.classList.add('is-visible');
            }
        } catch (error) {
            handleError(error, 'Failed to show text error');
        }
        };

        const clearFontError = (fontSelect) => {
        try {
            if (!fontSelect) {
            return;
            }

            fontSelect.classList.remove(
            'engraving-font-select--invalid'
            );

            const trigger = fontSelect.querySelector(
            '[data-font-trigger]'
            );

            if (trigger) {
            trigger.removeAttribute('aria-invalid');
            }

            const error = fontSelect
            .closest('.engraving-option')
            ?.querySelector('[data-font-error]');

            if (error) {
            error.hidden = true;
            error.classList.remove('is-visible');
            }
        } catch (error) {
            handleError(error, 'Failed to clear font error');
        }
        };

        const showFontError = (fontSelect) => {
        try {
            if (!fontSelect) {
            return;
            }

            fontSelect.classList.add(
            'engraving-font-select--invalid'
            );

            const trigger = fontSelect.querySelector(
            '[data-font-trigger]'
            );

            if (trigger) {
            trigger.setAttribute('aria-invalid', 'true');
            }

            const error = fontSelect
            .closest('.engraving-option')
            ?.querySelector('[data-font-error]');

            if (error) {
            error.hidden = false;
            error.classList.add('is-visible');
            }
        } catch (error) {
            handleError(error, 'Failed to show font error');
        }
        };

        const validateEngravingFields = (form) => {
        try {
            if (!form) {
            return true;
            }

            let isValid = true;
            let firstInvalidField = null;

            for (const container of getFormContainers(form)) {
            const activeGroup = container.querySelector(
                '.engraving-option-group:not([hidden])'
            );

            if (!activeGroup) {
                continue;
            }

            activeGroup
                .querySelectorAll('[data-engraving-input]')
                .forEach((input) => {
                if (input.disabled) {
                    return;
                }

                if (input.value.trim()) {
                    clearTextError(input);
                    return;
                }

                showTextError(input);
                isValid = false;

                if (!firstInvalidField) {
                    firstInvalidField = input;
                }
                });

            activeGroup
                .querySelectorAll('[data-selected-font-value]')
                .forEach((fontField) => {
                if (fontField.disabled) {
                    return;
                }

                const fontSelect = fontField.closest(
                    '[data-font-select]'
                );

                if (fontField.value.trim()) {
                    clearFontError(fontSelect);
                    return;
                }

                showFontError(fontSelect);
                isValid = false;

                if (!firstInvalidField) {
                    firstInvalidField = fontSelect?.querySelector(
                    '[data-font-trigger]'
                    );
                }
                });
            }

            firstInvalidField?.focus();
            return isValid;
        } catch (error) {
            handleError(error, 'Failed to validate engraving fields');
            return true;
        }
        };

        document.addEventListener(
        'submit',
        (event) => {
            try {
            const form = event.target;

            if (!(form instanceof HTMLFormElement)) {
                return;
            }

            if (!validateEngravingFields(form)) {
                event.preventDefault();
                event.stopPropagation();
            }
            } catch (error) {
            handleError(error, 'Form submit validation failed');
            }
        },
        true
        );

        /* Initialize using Liquid's initial variant. */
        const initializeEngraving = () => {
        try {
            const containers = getContainers();

            if (!containers.length) {
            console.warn(
                '[Engraving Options] No engraving containers found.'
            );

            return;
            }

            containers.forEach((container) => {
            try {
                const initialVariantTitle = (
                container.dataset.initialVariantTitle || ''
                ).toLowerCase();

                if (!initialVariantTitle) {
                console.warn(
                    '[Engraving Options] Initial variant title is missing.'
                );

                return;
                }

                updateEngravingVisibility({
                title: initialVariantTitle
                });
            } catch (error) {
                handleError(
                error,
                'Failed to initialize engraving container'
                );
            }
            });
        } catch (error) {
            handleError(
            error,
            'Failed to initialize engraving'
            );
        }
        };

        /* Shopify variant change event. */
        document.addEventListener('variant:change', (event) => {
        try {
            const {
            formId,
            variant,
            previousVariant
            } = event.detail || {};

            console.log('Variant changed:', {
            formId,
            variant,
            previousVariant
            });

            if (!variant) {
            console.warn(
                '[Engraving Options] Variant change event did not contain a variant.'
            );

            return;
            }

            /*
            * Shopify may re-render the section after this event.
            *
            * Run immediately first.
            */
            try {
            updateEngravingVisibility(variant);
            } catch (error) {
            handleError(
                error,
                'Immediate variant update failed'
            );
            }

            /*
            * Run again after Shopify has had a chance to
            * replace the product section.
            */
            requestAnimationFrame(() => {
            try {
                updateEngravingVisibility(variant);
            } catch (error) {
                handleError(
                error,
                'RequestAnimationFrame variant update failed'
                );
            }
            });

            /* Extra fallback for asynchronous section rendering. */
            setTimeout(() => {
            try {
                updateEngravingVisibility(variant);
            } catch (error) {
                handleError(
                error,
                'Delayed variant update failed'
                );
            }
            }, 100);
        } catch (error) {
            handleError(
            error,
            'Variant change handler failed'
            );
        }
        });

        /*
        * Restrict engraving text.
        *
        * Allowed:
        * - A-Z
        * - a-z
        * - 0-9
        * - spaces
        *
        * Maximum:
        * - 12 characters
        */
        const sanitizeEngravingInput = (input) => {
        try {
            if (!input) {
            return;
            }

            input.value = input.value
            .replace(/[^a-zA-Z0-9 ]/g, '')
            .slice(0, 12);

            const counter = input
            .closest('.engraving-option')
            ?.querySelector('[data-character-count]');

            if (counter) {
            counter.textContent = input.value.length;
            }

            if (input.value.trim()) {
            clearTextError(input);
            }
        } catch (error) {
            handleError(
            error,
            'Failed to sanitize engraving input'
            );
        }
        };

        /*
        * Use event delegation for engraving inputs.
        *
        * This continues working even if Shopify replaces
        * the engraving markup.
        */
        document.addEventListener('input', (event) => {
        try {
            if (!(event.target instanceof Element)) {
            return;
            }

            const input = event.target.closest(
            '[data-engraving-input]'
            );

            if (!input) {
            return;
            }

            sanitizeEngravingInput(input);
        } catch (error) {
            handleError(
            error,
            'Input event handler failed'
            );
        }
        });

        /* Handle paste. */
        document.addEventListener('paste', (event) => {
        try {
            if (!(event.target instanceof Element)) {
            return;
            }

            const input = event.target.closest(
            '[data-engraving-input]'
            );

            if (!input) {
            return;
            }

            requestAnimationFrame(() => {
            try {
                sanitizeEngravingInput(input);
            } catch (error) {
                handleError(
                error,
                'Paste sanitization failed'
                );
            }
            });
        } catch (error) {
            handleError(
            error,
            'Paste event handler failed'
            );
        }
        });

        /*
        * Font dropdown trigger.
        *
        * Event delegation means this also works after
        * Shopify section re-rendering.
        */
        document.addEventListener('click', (event) => {
        try {
            if (!(event.target instanceof Element)) {
            return;
            }


            /*
            * Font trigger.
            */
            const trigger = event.target.closest(
            '[data-font-trigger]'
            );

            if (trigger) {
            try {
                const fontSelect = trigger.closest(
                '[data-font-select]'
                );

                if (!fontSelect) {
                return;
                }

                const options = fontSelect.querySelector(
                '[data-font-options]'
                );

                if (!options) {
                console.warn(
                    '[Engraving Options] Font options element not found.'
                );

                return;
                }

                const isOpen =
                trigger.getAttribute('aria-expanded') === 'true';

                trigger.setAttribute(
                'aria-expanded',
                String(!isOpen)
                );

                options.hidden = isOpen;
            } catch (error) {
                handleError(
                error,
                'Font trigger failed'
                );
            }

            return;
            }

            /* Font option. */
            const option = event.target.closest(
            '[data-font-option]'
            );

            if (option) {
            try {
                const fontSelect = option.closest(
                '[data-font-select]'
                );

                if (!fontSelect) {
                return;
                }

                const trigger = fontSelect.querySelector(
                '[data-font-trigger]'
                );

                const options = fontSelect.querySelector(
                '[data-font-options]'
                );

                const selectedFont = fontSelect.querySelector(
                '[data-selected-font]'
                );

                const selectedFontValue = fontSelect.querySelector(
                '[data-selected-font-value]'
                );

                const font = option.dataset.font || '';

                if (!font) {
                console.warn(
                    '[Engraving Options] Selected font does not have a data-font value.'
                );
                }

                if (selectedFont) {
                selectedFont.textContent = font;
                }

                if (selectedFontValue) {
                selectedFontValue.value = font;
                }

                clearFontError(fontSelect);

                if (trigger) {
                trigger.setAttribute(
                    'aria-expanded',
                    'false'
                );
                }

                if (options) {
                options.hidden = true;
                }
            } catch (error) {
                handleError(
                error,
                'Font option selection failed'
                );
            }

            return;
            }

            /* Click outside font dropdown. */
            getContainers().forEach((container) => {
            try {
                container
                .querySelectorAll('[data-font-select]')
                .forEach((fontSelect) => {
                    try {
                    if (!fontSelect.contains(event.target)) {
                        const trigger = fontSelect.querySelector(
                        '[data-font-trigger]'
                        );

                        const options = fontSelect.querySelector(
                        '[data-font-options]'
                        );

                        if (trigger) {
                        trigger.setAttribute(
                            'aria-expanded',
                            'false'
                        );
                        }

                        if (options) {
                        options.hidden = true;
                        }
                    }
                    } catch (error) {
                    handleError(
                        error,
                        'Failed to close font dropdown'
                    );
                    }
                });
            } catch (error) {
                handleError(
                error,
                'Failed to process font dropdowns'
                );
            }
            });
        } catch (error) {
            handleError(
            error,
            'Click event handler failed'
            );
        }
        });

        /* Initial page load. */
        initializeEngraving();
    } catch (error) {
        handleError(
        error,
        'Fatal engraving script error'
        );
    }
    })();
    /* Custom engraving Code -- END */

});